import { render, staticRenderFns } from "./billing-address.vue?vue&type=template&id=b727d5e0"
import script from "./billing-address.vue?vue&type=script&lang=js"
export * from "./billing-address.vue?vue&type=script&lang=js"
import style0 from "./billing-address.vue?vue&type=style&index=0&id=b727d5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports